<template>
  <a-config-provider :locale="locale">
    <div id="app" class="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import resize from "@/mixins/resize";

export default {
  mixins: [resize],
  data() {
    return {
      locale: zhCN
    };
  }
};
</script>
<style lang="less" scoped>
.app {
  overflow-y: scroll;
}
</style>
